import * as React from "react";
import ClearableInputFormGroup from "../../ui/form/ClearableInputFormGroup";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {FocusableProps} from "../../common/props/FocusableProps";
import {DisableableProps} from "../../common/props/DisableableProps";
import {TrimableProps} from "../../common/props/TrimableProps";
import {EditableProps} from "../../common/props/EditableProps";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import CreatableSearchDropDown from "../../../hiberUiKit/src/molecules/SearchDropDown/CreatableSearchDropDown";
import {option} from "ts-option";
import "./contactTitleEditor.scss";

type Props = EditableProps & FormGroupProps<string> & PlaceholderProps & DisableableProps & FocusableProps & TrimableProps

interface IState {
	dropDownVisible: boolean
}

export default class ContactTitleEditor extends React.Component<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.onSelect = this.onSelect.bind(this);
		this.state = {dropDownVisible: false};
	}


	render() {
		return (
			<div className={"c-title-editor"}>
				<ClearableInputFormGroup label="Title"
										 placeholder={this.props.placeholder}
										 field={this.props.field}
										 focus={this.props.focus}
										 onChange={this.props.onChange}
										 onFocus={() => this.setState({dropDownVisible: true})}/>
				{this.state.dropDownVisible &&
				<DropDownWrapper autoWidth={true} onOutsideClick={() => this.setState({dropDownVisible: false})}>
					<TitleSelector onSelect={this.onSelect}/>
				</DropDownWrapper>
				}
			</div>
		);
	}

	/**
	 * On select update form field.
	 * @param title
	 */
	onSelect(title: string) {
		this.setState({dropDownVisible: false}, () => {
			this.props.onChange(this.props.field.updateValue(option(title)))
		});
	}
}

const titles = ["Mr.", "Mrs.", "Miss.", "Ms.", "Dr.", "Prof."];
export const TitleSelector: React.SFC<{ onSelect: (title: string) => void }> =
	(props) => <CreatableSearchDropDown items={titles}
										onSelect={props.onSelect}
										itemToLabel={(title: string) => title}
										itemToId={(title: string) => title}
										searchInputIcon={Icon.New}
										newOptionCreator={(title) => title}
										creatable={true}/>;